'use strict';
require('./section-handler-widget');
const mmWidgets = require('./mm-widgets');
mmWidgets.fn.goldDriveImportWidget = function (importModel) {
	return mmWidgets.each(this, function () {
		const widget = this.sectionHandlerWidget(),
			nameField = widget.find('[data-mm-role~=import-file-name]'),
			inprogressMessage = widget.find('[data-mm-role~="inprogress-message"]'),
			defaultProgressMessage = inprogressMessage.text() || 'Please wait...',
			showError = function (reason) {
				const predefinedMsg = widget.find('[data-mm-error~="' + reason + '"]');
				if (reason === 'not-subscribed') {
					return widget.showSection('not-subscribed');
				}
				widget.find('[data-mm-error]').addClass('hidden');
				if (predefinedMsg.length > 0) {
					predefinedMsg.removeClass('hidden');
				} else {
					widget.find('[data-mm-error~="default"]').removeClass('hidden');
				}
				widget.showSection('error');
			},
			showProgress = function (msg) {
				inprogressMessage.text(msg || defaultProgressMessage);
				widget.showSection('inprogress');
			},
			save = function () {
				const val = nameField.val();
				if (val && val.trim().length) {
					importModel.save(val);
					showProgress();
				} else {
					nameField.addClass('validation-error');
					nameField.focus();
				}
			};

		widget.find('[data-mm-role~=save]').on('click', save);
		nameField.on('keypress', function (e) {
			if (e.which === 13) {
				save();
			}
		});
		importModel.addEventListener('progress', (msg) => {
			showProgress(msg);
		});
		importModel.addEventListener('error', showError);
		importModel.addEventListener('readyToSave', function (fileName) {
			nameField.val(fileName);
			widget.showSection('initial');
		});
		importModel.addEventListener('requestConfirmation', function (reason) {
			widget.showSection('confirmation-' + reason);
		});
		importModel.addEventListener('complete', function () {
			widget.showSection('complete');
		});
	});
};
